import React from "react"
import PropTypes from 'prop-types'

import SelectGenericNew from "../../../../../gd-ui/select-generic-new/select-generic-new"

import {
    VALIDATION_BETWEEN,
    VALIDATION_CHANGED,
    VALIDATION_EMPTY,
    VALIDATION_EQUALS,
    VALIDATION_GREATER,
    VALIDATION_LABELS,
    VALIDATION_LESS,
    VALIDATION_NOT_EMPTY
} from "../../../../../model2/automation/lib/custom-field-validation";
import {FieldAutomationTriggerFormProps} from "../../../../render/automation-trigger-form";
import EditableInput from "../../../string/render/inline-editable/input-component";

const options = _.map([
    VALIDATION_CHANGED,
    VALIDATION_NOT_EMPTY,
    VALIDATION_EMPTY,
    VALIDATION_EQUALS,
    VALIDATION_GREATER,
    VALIDATION_LESS,
    VALIDATION_BETWEEN
], value=>({
    value: value,
    label: _.get(VALIDATION_LABELS, value)
}))

const debug = false
// const debug = "NumberTriggerForm"

export default class FieldNumber_AutomationTriggerForm extends React.Component<FieldAutomationTriggerFormProps, any> {

    static propTypes = {
        config          : PropTypes.object,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:FieldAutomationTriggerFormProps) {
        super(props)

        this.state = {
            validationType  : _.get(props.config, 'validationType', VALIDATION_CHANGED),
            value           : _.get(props.config, 'value', null),
            fromValue       : _.get(props.config, 'fromValue', null),
            toValue         : _.get(props.config, 'toValue', null)
        }
    }

    onChangeValidationType = (option:any) => {
        const validationType = option.value

        this.setState({
            validationType
        }, ()=>{
            this.props.onChangeCallback({validationType})
        })
    }

    onChangeValue = (value:any) => {
        this.setState({
            value
        }, ()=>{
            this.props.onChangeCallback({value})
        })
    }

    onChangeFromValue = (fromValue:any) => {
        this.setState({
            fromValue
        }, ()=>{
            this.props.onChangeCallback({fromValue})
        })
    }

    onChangeToValue = (toValue:any) => {
        this.setState({
            toValue
        }, ()=>{
            this.props.onChangeCallback({toValue})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        return (
            <React.Fragment>
                <div className="flex-row-left-top">
                    <div className="label w-100">Trigger when</div>
                    <SelectGenericNew className                     = "selector w-180"
                                      options                       = {options}
                                      value                         = {this.state.validationType}
                                      popoverScrollContainerClasses = "max-h-200 max-w-300"
                                      disabled                      = {this.props.config.disabled}
                                      onChange                      = {this.onChangeValidationType}/>
                </div>
                {[VALIDATION_EQUALS, VALIDATION_GREATER, VALIDATION_LESS].includes(this.state.validationType) &&
                    <div className="flex-row-left-top m-t-10">
                        <div className="label w-100"/>
                        <EditableInput className        = "ui5-txt-default ui5-field-form-editable w-200 h-36 p-l-10 p-r-10"
                                       inputClassName   = "ui5-txt-default"
                                       placeholder      = "Value"
                                       type             = "number"
                                       value            = {this.state.value}
                                       onChange         = {this.onChangeValue}/>
                    </div>}

                {[VALIDATION_BETWEEN].includes(this.state.validationType) &&
                    <div className="flex-row-left-top m-t-10">
                        <div className="label w-100"/>
                        <EditableInput className        = "ui5-txt-default ui5-field-form-editable w-150 h-36 p-l-10 p-r-10"
                                       inputClassName   = "ui5-txt-default"
                                       placeholder      = "Min value"
                                       type             = "number"
                                       value            = {this.state.fromValue}
                                       onChange         = {this.onChangeFromValue}/>
                        <div className="ui5-txt-not-important-small h-36 fl-ac m-r-10 m-l-10">-</div>
                        <EditableInput className        = "ui5-txt-default ui5-field-form-editable w-150 h-36 p-l-10 p-r-10"
                                       inputClassName   = "ui5-txt-default"
                                       placeholder      = "Max value"
                                       type             = "number"
                                       value            = {this.state.toValue}
                                       onChange         = {this.onChangeToValue}/>
                    </div>}
            </React.Fragment>
        )
    }

}
